import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./products-section.actions";

const initialState = {
  isFetchingStatus: STATUS.IDLE,
  products: [],
  drawingItems: [],
  drawingsList: null,
  selectedProductUids: [],
  selectedDrawingUids: [],
  errors: null,
};

export default createReducer(initialState, {
  [actions.setErrors]: createSetter("errors"),
  [actions.setIsFetchingStatus]: createSetter("isFetchingStatus"),
  [actions.setDrawingsList]: createSetter("drawingsList"),
  [actions.setDrawings]: createSetter("drawingItems"),
  [actions.setProducts]: createSetter("products"),
  [actions.setSelectedProductUids]: createSetter("selectedProductUids"),
  [actions.setSelectedDrawingUids]: createSetter("selectedDrawingUids"),

  [actions.reset]: () => ({ ...initialState }),
});
